const CURRENCY_SYMBOL = "€";

const moneyCompact = (value: number): string => {
    const abs = Math.abs(value);
    if (abs >= 1e9) return CURRENCY_SYMBOL + (value / 1e9).toFixed(2).replace(/\.00$/, "") + "B";
    if (abs >= 1e6) return CURRENCY_SYMBOL + (value / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    if (abs >= 1e3) return CURRENCY_SYMBOL + (value / 1e3).toFixed(0) + "K";
    return CURRENCY_SYMBOL + value.toFixed(0);
};

const money = (value: number): string =>
    CURRENCY_SYMBOL + new Intl.NumberFormat("en-US").format(Math.round(value));

const moneyPrecise = (value: number): string =>
    CURRENCY_SYMBOL +
    new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
        value
    );

const num = (value: number): string => new Intl.NumberFormat("en-US").format(Math.round(value));

const numShort = (value: number): string => {
    const abs = Math.abs(value);
    if (abs >= 1e6) return (value / 1e6).toFixed(2).replace(/\.00$/, "") + "M";
    if (abs >= 1e3) return (value / 1e3).toFixed(abs >= 1e4 ? 0 : 1).replace(/\.0$/, "") + "K";
    return String(Math.round(value));
};

const pct = (value: number, decimals = 1): string => value.toFixed(decimals) + "%";

const durationMs = (value: number): string => {
    if (value < 1000) return Math.round(value) + "ms";
    const seconds = value / 1000;
    if (seconds < 60) return Math.round(seconds) + "s";
    const minutes = seconds / 60;
    if (minutes < 60) return (minutes >= 10 ? Math.round(minutes).toString() : minutes.toFixed(1)) + "m";
    const hours = minutes / 60;
    if (hours < 24) return (hours >= 10 ? Math.round(hours).toString() : hours.toFixed(1)) + "h";
    const days = hours / 24;
    return (days >= 10 ? Math.round(days).toString() : days.toFixed(1)) + "d";
};

const signed = (value: number, body: string): string => (value >= 0 ? "+" : "") + body;

const deltaPct = (value: number): string => signed(value, value.toFixed(1) + "%");

const deltaPp = (value: number): string => signed(value, value.toFixed(1) + "pp");

const deltaBps = (value: number): string => signed(value, Math.round(value) + "bps");

export type DeltaKind = "up" | "down" | "flat";

const deltaKind = (value: number | null): DeltaKind => {
    if (value === null || Math.abs(value) < 0.05) return "flat";
    return value >= 0 ? "up" : "down";
};

export const investorsFormatters = {
    moneyCompact,
    money,
    moneyPrecise,
    num,
    numShort,
    pct,
    durationMs,
    deltaPct,
    deltaPp,
    deltaBps,
    deltaKind,
};
